import type { ReactNode } from "react";

export function Layout({ sidebar, main }: { sidebar: ReactNode; main: ReactNode }) {
  return (
    <div className="flex h-screen w-full flex-col md:flex-row">
      <aside className="w-full shrink-0 border-b border-panel-border md:w-60 md:border-b-0 md:border-r">
        {sidebar}
      </aside>
      <main className="flex-1 overflow-y-auto p-4 md:p-6">{main}</main>
    </div>
  );
}
